// extracted by mini-css-extract-plugin
module.exports = {"audioController":"index-audioController-15Rpv","progressController":"index-progressController-3aInU"};